import React from "react";

function BS4_Tooltip() {
  return (
    <div>
      <h1>BS4_Tooltip Component</h1>
      <p>This is the BS4_Tooltip tutorial page content.</p>
    </div>
  );
}

export default BS4_Tooltip;
